<template>
  <div class="spinner-wrapper">
    <div class="spinner-ring"></div>
    <img class="spinner-logo" :src="logoF" alt="FlixLatino" />
  </div>
</template>

<script setup lang="ts">
import logoF from "@/assets/img/logo-f.svg";
</script>

<style scoped lang="scss">
.spinner-wrapper {
  position: relative;
  width: 8rem;
  height: 8rem;

  display: flex;
  align-items: center;
  justify-content: center;

  pointer-events: none;
}

.spinner-ring {
  position: absolute;
  inset: 0;

  border: 4px solid rgba(var(--v-theme-on-surface), 0.2);
  border-top-color: rgb(var(--v-theme-primary));

  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.spinner-logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
  display: block;
  position: relative;
  z-index: 1;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
